import Loading from '@shared/components/Loading';
import React, { memo, PropsWithChildren, useState } from 'react';

import HeaderComponent from './Header';
import SiderComponent from './Sidebar';

interface IDefaultLayoutProps {
  hideSideBar?: boolean;
  hideHeader?: boolean;
  loading?: boolean;

}

const DefaultLayout: React.FC<PropsWithChildren<IDefaultLayoutProps>> = props => {
  const [menu, setMenu] = useState<string>('sider-component big');

  const onClick = (e: any): any => {
    const targetNode = e.target as HTMLDivElement;
    if (targetNode.className === 'main-component big' || e.target === e.currentTarget) {
      setMenu('sider-component big');
      return;
    }
    if (
      targetNode.tagName === 'INPUT' ||
      targetNode.tagName === 'BUTTON' ||
      targetNode.parentElement?.onclick !== null
    ) {
      return;
    }
    setMenu('sider-component big');
  };

  return (
    <div className="all-page-component">
      {props.hideSideBar !== true && <SiderComponent setClassName={setMenu} className={menu} />}
      <div className="right-page-component" onClick={onClick}>
        <div className="main-component">
          {props.hideHeader !== true && <HeaderComponent />}
          {props.children}
        </div>
        {props.loading && <div className='w-100 h-100 div-mask'><Loading/></div>}
      </div>
    </div>
  );
};

export default memo(DefaultLayout);
